import DEFINES from './defines';
import moment from 'moment';
import i18n from '@/i18n';
import momentTz from 'moment-timezone';

const getAddToCalLink = screener => {
  if (screener) {
    let ATCAL_BASE_URL = DEFINES.ADD_TO_CAL_BASE_URL;
    let params = _getParams (screener);
    let absolute_url = _appendParams (ATCAL_BASE_URL, params);
    return absolute_url;
  }
};

const _getParams = screener => {
  return {
    action: 'TEMPLATE',
    text: screener.title,
    dates: _getFormattedDate (screener.screening_starts_at) +
      '/' +
      _getFormattedDate (screener.screening_ends_at),

    details: i18n.t ('screener.add_to_cal.more_detail') + DEFINES.APP_URL,
    location: screener.venue,
  };
};

const _getFormattedDate = date => {
  let format = 'YYYYMMDDTHHmmSS';
  return moment.utc (date).local ().format (format);
};

const _appendParams = (base_url, params) => {
  if (params) {
    for (let key in params) {
      if (params.hasOwnProperty (key)) {
        let value = params[key];
        base_url += key + '=' + value + '&';
      }
    }
    base_url += 'sprop=website:' + DEFINES.APP_URL;
  }
  return base_url;
};

const getZoomUrl = screener_id => {
  return process.env.VUE_APP_SERVER_URL + 'screener/' + screener_id;
};

const getFacebookLiveEmbedUrl = (videoId, shouldAutoPlay = true) => {
  /**
   * if force set autoplay
   */
  if(shouldAutoPlay){
    return process.env.VUE_APP_SERVER_URL + 'screener/facebook/' + videoId + '/' + true;
  }
  return process.env.VUE_APP_SERVER_URL + 'screener/facebook/' + videoId;
};

const getVimeoEmbedUrl = (vimeo_live_id, shouldAutoPlay = true) => {
   /**
   * if force set autoplay
   */
  if(shouldAutoPlay){
    return 'https://vimeo.com/event/' + vimeo_live_id + '/embed?autoplay=1';
  }
  return 'https://vimeo.com/event/' + vimeo_live_id + '/embed';
};

const getVimeoChatEmbedUrl = vimeo_live_id => {
  return 'https://vimeo.com/event/' + vimeo_live_id + '/chat/';
};

const utcToTz = (input, timezone, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  if(!input){
    return null;
  }
  return momentTz.utc (input, 'YYYY-MM-DD HH:mm:ss').tz (timezone).format (fmt);
};

const isSecondaryColorWhite = company => {
  var custom_pro = company.hasOwnProperty ('custom_properties')
    ? company.custom_properties
    : null;
  if (
    custom_pro &&
    custom_pro.theme.secondaryColor &&
    custom_pro.theme.secondaryColor.match (/^(#fff|#ffffff)$/i)
  ) {
    return true;
  }
  return false;
};

const getCurrencySymbol = currency => {
  return DEFINES.MONETIZATION.CURRENCIES.find (
    currencyObj => currency.toLowerCase () == currencyObj.value.toLowerCase ()
  ).symbol;
};

const isDateFuture = date => {
  let today_date = moment ();
  let future_date = moment.utc (date).local ();
  /* future - today > 0  || today - future < 0 */
  return future_date.diff (today_date) > 0;
};

const getInPercent = (num1 = 0, num2) => {
  if (!num2) return 0;
  return num1 * 100 / num2;
};

const getYoutubeLiveEmbedUrl =  (videoId, shouldAutoPlay = true) => {
   /**
   * if force set autoplay
   */
  if(shouldAutoPlay){
    return 'https://www.youtube.com/embed/'+videoId+'?autoplay=1';
  }
  return 'https://www.youtube.com/embed/'+videoId;
}

const isDatePast = (date) => {
  let today_date = moment().utc().format('YYYY-MM-DD HH:mm:ss');
  return date < today_date;
}

const isDateGreaterThenNow = (date) => {
  let today_date = moment().utc().format('YYYY-MM-DD HH:mm:ss');
  return date > today_date;
}

const isDateLessThenNow = (date) => {
  let today_date = moment().utc().format('YYYY-MM-DD HH:mm:ss');
  return date < today_date;
}
// Function to check future date with time against current date time
const isDateTimePast = (endDateTime, format="YYYY-MM-DD HH:mm:ss") => {
  let currentDateTime = moment().format(format);
  let dateTime = moment.utc (endDateTime).local().format(format);
  return moment(currentDateTime).isAfter(dateTime);
}

const generateNewUUID = function(){
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (dt + Math.random()*16)%16 | 0;
      dt = Math.floor(dt/16);
      return (c=='x' ? r :(r&0x3|0x8)).toString(16);
  });
  return uuid;
}

const getRemainingTime = subscription => {
  var today = moment();
  var trial_end = moment.unix(subscription.trial_end);
  if (subscription.trial_end && trial_end > today) {
    return getTimeDifference(trial_end);
  }
  if (subscription.cancel_at_period_end) {
    var period_end = moment.unix(subscription.current_period_end);
    return getTimeDifference(period_end);
  }
};

const getTimeDifference = end_date => {
  return moment.utc(end_date).local().fromNow();
};

const getFormattedTimeString = (milliseconds, dateTimeFormat) => {
  return moment.unix(milliseconds).format(dateTimeFormat);
};

export {
  getAddToCalLink,
  utcToTz,
  getCurrencySymbol,
  isSecondaryColorWhite,
  getZoomUrl,
  getVimeoEmbedUrl,
  getVimeoChatEmbedUrl,
  isDateFuture,
  getFacebookLiveEmbedUrl,
  getInPercent,
  getYoutubeLiveEmbedUrl,
  isDatePast,
  isDateGreaterThenNow,
  isDateLessThenNow,
  isDateTimePast,
  generateNewUUID,
  getRemainingTime,
  getTimeDifference,
  getFormattedTimeString,
};
